import { useSearchParams } from "react-router-dom";
import BackButton from "../../components/BackButton";
import SizingChartsMockBanner from "../../components/setup/SizingChartsMockBanner";
import SizingChartEditorForm from "../../components/setup/SizingChartEditorForm";
import { DEFAULT_CHART_PARAM, LINGERIE_CHART_PARAM } from "../../types/types";

export default function CreateSizingChart() {
  const [searchParams] = useSearchParams();
  const raw = searchParams.get("categoryParam");
  const categoryParam =
    raw === LINGERIE_CHART_PARAM ? LINGERIE_CHART_PARAM : DEFAULT_CHART_PARAM;

  return (
    <div className="container">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 mb-8">
        <div className="flex items-center gap-2">
          <BackButton className="mr-1" defaultPath="/sizing-charts" />
          <h1 className="page-title mb-0">Create Sizing Chart</h1>
        </div>
      </div>
      <SizingChartsMockBanner />
      <SizingChartEditorForm
        categoryParam={categoryParam}
        routeChartId={null}
        mode="create"
      />
    </div>
  );
}
